import script from "./ransomware-incident-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ransomware-incident-detail.vue?vue&type=script&setup=true&lang=ts"

import "./ransomware-incident-detail.vue?vue&type=style&index=0&id=1b3a965d&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b3a965d"]])

export default __exports__